
export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-trophy-line',
      title: '100+ Premium Machines',
      description: 'One of Kenya\'s biggest gyms with over 100 high-quality strength and cardio machines',
      color: 'from-red-600 to-red-700'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Professional Trainers',
      description: 'Expert trainers providing personalized guidance and free screening',
      color: 'from-gray-700 to-gray-800'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Clean Facilities',
      description: 'Well-maintained, spotless gym environment for safe workouts',
      color: 'from-red-600 to-red-700'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Affordable Rates',
      description: 'Daily pass at 500 KES and monthly membership at only 4,650 KES',
      color: 'from-gray-700 to-gray-800'
    },
    {
      icon: 'ri-shopping-bag-line',
      title: 'Supplements & Merch',
      description: 'Quality supplements and branded merchandise available on-site',
      color: 'from-red-600 to-red-700'
    },
    {
      icon: 'ri-team-line',
      title: 'Conditioning Accessories',
      description: 'Complete range of conditioning accessories and equipment',
      color: 'from-gray-700 to-gray-800'
    }
  ];

  return (
    <section id="equipment" className="py-12 lg:py-24 bg-gradient-to-b from-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="text-center mb-6 lg:mb-16">
          <div className="inline-block px-2 py-1 lg:px-4 lg:py-2 bg-red-600/20 border border-red-500/50 text-red-400 rounded-lg text-[10px] lg:text-sm font-bold mb-2 lg:mb-4 uppercase tracking-wider">
            WHY CHOOSE HFC GYM
          </div>
          <h3 className="text-2xl lg:text-6xl font-black text-white mb-2 lg:mb-6 tracking-tight">
            Fully Equipped For <span className="text-red-500">Your Success</span>
          </h3>
          <p className="text-xs lg:text-xl text-gray-400 max-w-3xl mx-auto">
            Everything you need to achieve your fitness goals
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group relative bg-gray-800 rounded-lg lg:rounded-lg p-3 lg:p-8 border border-gray-700 hover:border-red-600 transition-all duration-500 hover:-translate-y-2 overflow-hidden"
            >
              {/* Gradient Background on Hover */}
              <div className={`absolute inset-0 bg-gradient-to-br ${feature.color} opacity-0 group-hover:opacity-10 transition-opacity duration-500`}></div>
              
              <div className="relative z-10">
                {/* Icon */}
                <div className={`w-8 h-8 lg:w-16 lg:h-16 rounded-lg bg-gradient-to-br ${feature.color} flex items-center justify-center mb-2 lg:mb-6 group-hover:scale-110 transition-transform duration-500`}>
                  <i className={`${feature.icon} text-base lg:text-3xl text-white`}></i>
                </div>

                {/* Content */}
                <h4 className="text-xs lg:text-2xl font-bold text-white mb-0.5 lg:mb-3 uppercase tracking-wide leading-tight">
                  {feature.title}
                </h4>
                <p className="text-gray-400 leading-relaxed text-[10px] lg:text-base hidden lg:block">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
